import styled from 'styled-components';

export const AvailableLanguagesContainer = styled.section`
  position: relative;
  z-index: 0;
  overflow: hidden;
  background-color: var(--brandColor);
  padding: 20px 0px 35px 0px;
  margin-bottom: ${(props) => (props.noMarginBottom ? 'unset' : '35px')};
  border-radius: 10px;
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-image: var(--stripedBlueBg);
    background-size: 18px 18px;
    opacity: 1;
    z-index: -1;
  }
`;

export const AvailableLanguagesHeading = styled.h4`
  color: var(--white);
  text-align: center;
  padding: 0px 8px 20px !important;
  line-height: 1.5rem;
  font-size: 18px !important;
  @media (min-width: 768px) {
    line-height: 1.6rem;
    font-size: 20px !important;
  }
  @media (min-width: 992px) {
    line-height: 1.7rem;
    font-size: 22px !important;
  }
  @media (min-width: 1200px) {
    line-height: 1.8rem;
    font-size: 24px !important;
  }
`;

export const AvailableLanguagesHeadingSpecial = styled.h4`
  display: inline;
  color: var(--dark);
  white-space: nowrap;
  font-size: 18px !important;
  padding: 0px 4px;
  padding-bottom: 0px;
  background: #fcdd4c;
  border-radius: 2px;

  @media (min-width: 768px) {
    font-size: 20px !important;
  }
  @media (min-width: 992px) {
    font-size: 22px !important;
  }
  @media (min-width: 1200px) {
    font-size: 24px !important;
  }
`;

export const AvailableLanguageHeadingIcon = styled.img`
  margin-left: 5px;
  width: 20px;
  @media (min-width: 768px) {
    width: 22px !important;
  }
  @media (min-width: 992px) {
    width: 24px !important;
  }
  @media (min-width: 1200px) {
    width: 26px !important;
  }
`;

export const AvailableLanguageCardWrapper = styled.div`
  height: 100%;
  padding: 0px 8px;
  @media (min-width: 576px) {
    padding: 0px 12px;
  }
`;

export const AvailableLanguagePara = styled.p`
  color: ${(props) => (props.active ? 'var(--orange)' : 'var(--dark)')};
  text-align: center;
  font-size: 14px;
  font-family: var(--headingFont);
  font-weight: ${(props) => (props.active ? '500' : '400')};
  padding: 0px 10px;
  transition: 0.1s ease;
`;

export const AvailableLanguagesImgWrapper = styled.div`
  width: 75px;
  height: 75px;
  margin: 0px auto;
  transition: 0.1s ease;
`;

export const AvailableLanguageCard = styled.div`
  display: block;
  height: 100%;
  text-align: center;
  border-radius: 6px;
  padding-bottom: 10px;
  background-color: var(--white);
  border: ${(props) => (props.active ? '2px solid var(--orange)' : '2px solid transparent')};
  cursor: ${({ nonClickable }) => (nonClickable ? 'default' : 'pointer')};
  &:hover > ${AvailableLanguagePara} {
    transform: scale(1.05);
    font-weight: 500;
  }
  &:hover > ${AvailableLanguagesImgWrapper} {
    transform: scale(1.1);
  }
`;
